<template>
<keep-alive>
    <div>
    <v-toolbar 
      flat 
      dark 
      fixed
      >
      <v-toolbar-title>
        <v-card 
          color="white">
          <router-link 
            :to="{
              name: 'clients'
            }" 
            tag="span">
            <v-img
              :src="logo_src"
              contain
              min-height="50"
              min-width="50"
              max-height="70"
              max-width="70"
            />
          </router-link>
        </v-card>
      </v-toolbar-title>
      <v-spacer/>

      <v-toolbar-items
      v-if="$store.state.isUserLoggedIn" 
        dark 
        flat>
        <div v-cloak>
        <v-btn-toggle 
          v-model="toggle_test_type" 
          flat 
          dark 
          mandatory>
          <v-flex 
            align-start
            justify-center>
            <v-btn 
              :value="sd" 
              flat 
              dark 
              large 
              @click="goToClients(sd)">
              <v-card-text>RMP for Self-Discovery</v-card-text>
            </v-btn>
          </v-flex>
          <v-flex>
            <v-btn 
              :value="business" 
              flat 
              dark 
              large 
              @click="goToClients(business)">
              <v-card-text>RMP for Business</v-card-text>
            </v-btn>
          </v-flex>
          <v-flex>
            <v-btn 
              :value="sports" 
              flat 
              dark 
              large 
              @click="goToClients(sports)">
              <v-card-text>RMP for Sports</v-card-text>
            </v-btn>
          </v-flex>
          <v-flex>
            <v-btn 
              :value="school" 
              flat 
              dark 
              large 
              @click="goToClients(school)">
              <v-card-text>Reiss School Motivation Profile</v-card-text>
            </v-btn>
          </v-flex>
        </v-btn-toggle>
        </div>
      </v-toolbar-items>

      <v-spacer/>

      <v-toolbar-items>
        <v-btn
          v-if="!$store.state.isUserLoggedIn"
          :to="{
          name: 'login'
        }"
          flat
          dark
        >Login</v-btn>
        <v-btn
          v-if="!$store.state.isUserLoggedIn"
          :to="{
          name: 'register'
        }"
          flat
          dark
        >Register</v-btn>
        <v-btn 
          v-if="$store.state.isUserLoggedIn" 
          flat 
          dark 
          @click="logout">Log Out</v-btn>
      </v-toolbar-items>
      <template v-slot:extension>
      <v-btn-toggle
        v-if="$store.state.isUserLoggedIn" 
        v-model="toggle_screen_type"    
        mandatory         
        >
        <v-flex>
        <v-btn
          :value="client_toggle_val"
          flat
          dark
          large
          @click="setScreenView(client_toggle_val,'clients')"
          >Clients
         </v-btn>
        </v-flex>
          <v-flex>
        <v-btn
            :value="group_toggle_val"
            flat
            dark
            large
            @click="setScreenView(group_toggle_val,'groups')"
        >Groups
        </v-btn>
      </v-flex>
     
        <v-flex>
        <v-btn
          :value="me_edit_toggle_val"
          flat
          dark
          large
          @click="setScreenViewMeEdit"
        >My Information</v-btn>
        </v-flex>
       <v-flex xs3/>
        <v-flex>
          <v-btn
            v-if="$store.state.isUserLoggedIn && $store.state.user && $store.state.user.role && $store.state.user.role==='Admin'"
          :value="users_toggle_val"
          
            flat
            dark
            large
            @click="setScreenView(users_toggle_val, 'users')"
          >Admin: Edit Users
        </v-btn>
        </v-flex>
      </v-btn-toggle>
     </template>
    </v-toolbar>
    <v-spacer/>
    </div>
 </keep-alive>
</template>

<script>
import {
  SD,
  SPORTS,
  BUSINESS,
  SCHOOL,
  RELATIONSHIP,
  STRONG_COLOR,
  GROUP_TOGGLE,
  ME_EDIT_TOGGLE,
  USERS_TOGGLE,
  CLIENT_TOGGLE
} from "@/components/globals/consts"
import rmp_tagline from "@/assets/rmp_acronym.png"
import { mapState } from "vuex"
import EventBus from "@/main.js"
import _ from 'lodash'

export default {
  data() {
    return {
      sd: SD,
      sports: SPORTS,
      business: BUSINESS,
      school: SCHOOL,
      relationship: RELATIONSHIP,
      logo_src: rmp_tagline,
      toggle_test_type: BUSINESS,
      strongColor: STRONG_COLOR,
      toggle_screen_type: CLIENT_TOGGLE,
      client_toggle_val: CLIENT_TOGGLE,
      group_toggle_val: GROUP_TOGGLE,
      users_toggle_val: USERS_TOGGLE,
      me_edit_toggle_val: ME_EDIT_TOGGLE

    };
  },
  computed: {
    ...mapState(["isUserLoggedIn", "user", "route", "testType", "screenType"])
  },
    async mounted () {
    
    if (!this.isUserLoggedIn) {
			this.$router.push({
				name: 'login'
			})
    }
    this.toggle_screen_type = this.screenType
  },
  // async beforeDestroy() {

  //   console.log('before destroy')
  //   this.toggle_screen_type = null
  //   //this.toggle_test_type = null
  // },
  methods: {
    async logout() {
      this.toggle_screen_type = null
      //this.toggle_test_type = null
      await this.$store.dispatch("setTestType", null);
      await this.$store.dispatch("setScreenType", null);
      await this.$store.dispatch("setGroupName", null);
      //await this.$store.dispatch("setTestAttributes", null);
      await this.$store.dispatch("setGroupId", null);
      await this.$store.dispatch("setRenderClientList", null);
      await this.$store.dispatch("setClientsToRemoveFromGroup", null);
      await this.$store.dispatch("setCurrentClient", null);
      await this.$store.dispatch("setCheckedAttrs", null);
      await this.$store.dispatch("setCurrentGroupClients", []);
      await this.$store.dispatch("setUser", null);
      await this.$store.dispatch("setToken", null);
    
      await this.$router.push({
        name: "login"
      });
    },
    // async setTestType(testType) {
    //    await this.$store.dispatch("setTestType", testType);
           // },
    setScreenView: _.debounce(async function (toggle_val, route_val)  {
      this.toggle_screen_type = toggle_val
      await this.$store.dispatch("setScreenType", toggle_val);
      await this.$router.push({
        name: route_val
      })
    }, 700),
    async setScreenViewMeEdit() {
      this.toggle_screen_type = this.me_edit_toggle_val
       await this.$store.dispatch("setScreenType", this.me_edit_toggle_val);
      
      await this.$router.push( {
          name: 'me-edit',
          params: {
            userId: this.$store.state.user.id
          }
        }) 
   },
    goToClients: _.debounce(async function (testType) {
    try {
      await this.$store.dispatch("setTestType", testType);
      await this.$store.dispatch("setCurrentGroupClients", []);
      await this.$store.dispatch("setClientsToRemoveFromGroup", null);
      this.toggle_screen_type = this.client_toggle_val
      await this.emitMethod("renderClients", "");
      await this.$router.push({
        name: 'clients'
      })
    } catch (error) {
      this.error = error.response.data.error;
    }
  }, 700),
    async emitMethod(name, value) {
      try {
        await EventBus.$emit(name, value);
      } catch (e) {
        //console.log(e);
      }
    }
  }
};
</script>

<style scoped>
.home {
  cursor: pointer;
}
.v-btn {
  background-color: #0065bd;
  color: white;
  font-size: 16px;
}
.v-btn-toggle {
  background-color: #0065bd;
}
.v-toolbar {
  background-color: #0065bd;
}
.v-toolbar-items {
  background-color: #0065bd;
}
.v-card {
  background-color: #0065bd;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue